module.exports = __webpack_public_path__ + "img/pause.6c669a87.png";